import React from 'react'

const AuthUserContext = React.createContext(null)

export default AuthUserContext


// WEBPACK FOOTER //
// ./src/common/components/auth-user-context.js